var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "layout-coupon"
  }, [_c('header'), _c('div', {
    staticClass: "main-content"
  }, [_vm.isLoading ? _c('div', {
    staticClass: "load"
  }) : _c('router-view')], 1), _c('footer')]);
}
var staticRenderFns = []

export { render, staticRenderFns }